import React, { createContext, useContext, useState, useCallback } from 'react';

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  const [menuVisibilityState, setMenuVisibilityState] = useState(() => {
    try {
      const saved = localStorage.getItem('menuVisibilityState');
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  const [groupOpenState, setGroupOpenState] = useState(() => {
    try {
      const saved = localStorage.getItem('menuGroupOpenState_v2');
      if (saved) return JSON.parse(saved);
    } catch {}
    // Por defeito: todos os grupos fechados
    return {};
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [editMode, setEditMode] = useState(false);

  // Abrir um grupo específico (fecha todos os outros)
  const openGroup = useCallback((groupId) => {
    const next = { [groupId]: true };
    setGroupOpenState(next);
    try { localStorage.setItem('menuGroupOpenState_v2', JSON.stringify(next)); } catch {}
  }, []);

  // Toggle com comportamento acordeão: ao abrir um, fecha os restantes
  const toggleGroup = useCallback((groupId) => {
    setGroupOpenState((prev) => {
      const isCurrentlyOpen = !!prev[groupId];
      const next = isCurrentlyOpen ? {} : { [groupId]: true };
      try { localStorage.setItem('menuGroupOpenState_v2', JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  const updateMenuVisibility = useCallback((state) => {
    try {
      setMenuVisibilityState(state);
      localStorage.setItem('menuVisibilityState', JSON.stringify(state));
    } catch (error) {
      console.error('Erro ao guardar menu state:', error);
    }
  }, []);

  const value = {
    menuVisibilityState,
    updateMenuVisibility,
    groupOpenState,
    toggleGroup,
    openGroup,
    selectedProduct,
    setSelectedProduct,
    editMode,
    setEditMode
  };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout deve ser usado dentro de LayoutProvider');
  }
  return context;
};